export const pipe = <T extends any[], R>(fn1: (...args: T) => R, ...fns: Array<(a: R) => R>) => {
    const piped = fns.reduce(
        (prevFn, nextFn) => (value: R) => nextFn(prevFn(value)),
        value => value,
    );
    return (...args: T) => piped(fn1(...args));
};

export const compose = <R>(fn1: (a: R) => R, ...fns: Array<(a: R) => R>) =>
    fns.reduce((prevFn, nextFn) => value => prevFn(nextFn(value)), fn1);

type Environment = 'production' | 'release' | 'development' | 'development-production';

export const getEnv = (): Environment =>
    ((typeof window !== 'undefined' && window.CONFIG_ENV) ||
        process.env.CONFIG_ENV ||
        process.env.NODE_ENV ||
        'development') as Environment;

export const escapeHtml = (text: string = '') => {
    const encodeMap: Record<string, string> = {
        '<': '\\u003C',
        '>': '\\u003E',
        // '/': '\\u002F',
    };

    return text.replace(/[<>]/g, match => {
        return encodeMap[match];
    });
};
